__turbopack_context__.v({
  "captionopen": "IJ6SUa_captionopen",
  "context": "IJ6SUa_context",
  "explanatory": "IJ6SUa_explanatory",
  "giveButtonWrapper": "IJ6SUa_giveButtonWrapper",
  "grid": "IJ6SUa_grid",
  "header": "IJ6SUa_header",
  "innerParagraphNumber": "IJ6SUa_innerParagraphNumber",
  "input": "IJ6SUa_input",
  "inputWrapper": "IJ6SUa_inputWrapper",
  "output": "IJ6SUa_output",
  "paragraphNumber": "IJ6SUa_paragraphNumber",
  "paragraphWrapper": "IJ6SUa_paragraphWrapper",
  "select": "IJ6SUa_select",
  "selected": "IJ6SUa_selected",
  "spinnerWrapper": "IJ6SUa_spinnerWrapper",
  "wrapper": "IJ6SUa_wrapper",
});
